import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const EditIntroductiong = () => {
    const [introduction, setIntroduction] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('userEmail');

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Check if introduction includes a valid URL
        const urlPattern = /(https?:\/\/[^\s]+)/g;
        if (!urlPattern.test(introduction)) {
            alert("Please include a valid web address in the introduction.");
            return;
        }

        if (!introduction) {
            alert("Introduction cannot be empty.");
            return;
        }

        const data = { introduction, userEmail };

        try {
            const response = await fetch('/update_introductiong', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            const result = await response.json();
            setMessage(result.message);
        } catch (error) {
            console.error('There was an error storing the introduction!', error);
        }
    };

    const handleBack = () => {
        navigate(-1);
    };

    if (!userEmail) {
        navigate('/signin');
        return null;
    }

    return (
        <div style={{ textAlign: 'center' }}>
            <h2 style={{ color: 'blue' }}>INTRODUCTION</h2>
            <br />
            <p>Signed in as: {userEmail}</p>
            <form method="POST" onSubmit={handleSubmit} style={{ display: 'inline-block', textAlign: 'left', width: '60%', margin: '0 auto' }}>
                <label htmlFor="Introduction"></label>
                <textarea
                    name="Introduction"
                    id="Introduction"
                    rows="10"
                    placeholder="Introduction"
                    value={introduction}
                    onChange={(e) => setIntroduction(e.target.value)}
                    style={{ width: '100%', padding: '10px', boxSizing: 'border-box', borderRadius: '5px', border: '1px solid #ccc' }}
                ></textarea>
                <br />
                <input style={{ backgroundColor: 'pink', marginTop: '10px', padding: '10px 20px', borderRadius: '5px', border: 'none', cursor: 'pointer' }} type="submit" value="Submit" />
            </form>

            {message && <p>{message}</p>}

            <br />
            <br />
            <input
                style={{ backgroundColor: 'lightblue', padding: '10px 20px', borderRadius: '5px', border: 'none', cursor: 'pointer' }}
                type="button"
                value="Back"
                className="button login__submit"
                onClick={handleBack}
            />
            <footer id="footer" className="footer" style={{ marginTop: '40px', padding: '20px 0', backgroundColor: '#f8f9fa' }}>
                <div className="container">
                    <div className="row gy-3">
                        <div className="col-lg-3 col-md-6 d-flex">
                            <i className="bi bi-geo-alt icon"></i>
                            <div>
                                <h4>Address</h4>
                                <p>
                                    Plot No. 22B, Attibele Industrial Area
                                    <br />
                                    Anekal Taluk, Bangalore-562107-IND
                                    <br />
                                </p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 footer-links d-flex">
                            <i className="bi bi-telephone icon"></i>
                            <div>
                                <h4>Appointments</h4>
                                <p>
                                    <strong>Phone:</strong> Tel: +91 99160 70034 | 95134 99976
                                    <br />
                                    <strong>Email:</strong> sales@hydaxindia.com
                                    <br />
                                </p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 footer-links d-flex">
                            <i className="bi bi-clock icon"></i>
                            <div>
                                <h4>Opening Hours</h4>
                                <p>
                                    <strong>Mon-Sat: 9AM</strong> - 5:30PM
                                    <br />
                                    Sunday: Closed
                                </p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 footer-links">
                            <h4>Follow Us</h4>
                            <div className="social-links d-flex">
                                <a href="#" className="twitter">
                                    <i className="bi bi-twitter"></i>
                                </a>
                                <a href="#" className="facebook">
                                    <i className="bi bi-facebook"></i>
                                </a>
                                <a href="#" className="instagram">
                                    <i className="bi bi-instagram"></i>
                                </a>
                                <a href="#" className="linkedin">
                                    <i className="bi bi-linkedin"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="copyright">
                        <strong>
                            <span></span>
                        </strong>
                        Copyright � 2022 HYDAX HYDRAULICS PVT. LTD.
                    </div>
                    <div className="credits">
                        {/* All the links in the footer should remain intact. */}
                        {/* You can delete the links only if you purchased the pro version. */}
                        {/* Licensing information: https://bootstrapmade.com/license/ */}
                        {/* Purchase the pro version with working PHP/AJAX contact form: https://bootstrapmade.com/yummy-bootstrap-restaurant-website-template/ */}
                        <a href="https://bootstrapmade.com/"></a>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default EditIntroductiong;
